(function () {
  var wrap = document.getElementById('csWrap');
  if (!wrap) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var filters = document.getElementById('csFilters');
  var mobileBtn = document.getElementById('csMobileFilterBtn');
  var grid = document.getElementById('csProductGrid');
  var sortPillsWrap = document.getElementById('csSortPills');

  /* ---------- mobile filter drawer ---------- */
  if (mobileBtn && filters) {
    mobileBtn.addEventListener('click', function () {
      var open = filters.classList.toggle('is-open');
      mobileBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- collapsible facet groups ---------- */
  document.querySelectorAll('[data-cs-toggle]').forEach(function (title) {
    title.addEventListener('click', function () {
      title.closest('.cs-facet').classList.toggle('is-collapsed');
    });
  });

  /* ---------- checkbox filters (native Shopify filter URLs) ---------- */
  document.querySelectorAll('[data-cs-filter-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var url = input.checked
        ? input.getAttribute('data-url-add')
        : input.getAttribute('data-url-remove');
      if (url) window.location.href = url;
    });
  });

  /* ---------- sort pills ---------- */
  if (sortPillsWrap) {
    sortPillsWrap.querySelectorAll('[data-sort-value]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', pill.getAttribute('data-sort-value'));
        window.location.search = params.toString();
      });
    });
  }

  /* ---------- per-card hover animation (JS-driven, not CSS :hover) ---------- */
  function wireCard(card) {
    if (card.dataset.csWired) return;
    card.dataset.csWired = 'true';
    card.addEventListener('mouseenter', function () { card.classList.add('is-active'); });
    card.addEventListener('mouseleave', function () { card.classList.remove('is-active'); });
    card.addEventListener('focusin', function () { card.classList.add('is-active'); });
    card.addEventListener('focusout', function () { card.classList.remove('is-active'); });
  }
  document.querySelectorAll('[data-cs-card]').forEach(wireCard);

  /* ---------- Add-to-cart button ---------- */
  function bumpCartCount(count) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count } }));
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function wireAddButton(btn) {
    if (btn.dataset.csWired) return;
    btn.dataset.csWired = 'true';

    btn.addEventListener('click', function (e) {
      var canQuickAdd = btn.getAttribute('data-can-quick-add') === 'true';
      var variantId = btn.getAttribute('data-variant-id');

      if (!canQuickAdd || !variantId) {
        // Product needs variant selection — let the card link do its normal job.
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          bumpCartCount(cart.item_count);
          setTimeout(function () {
            btn.textContent = originalText;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          window.location.href = btn.getAttribute('data-product-url');
        });
    });
  }
  document.querySelectorAll('[data-cs-add-btn]').forEach(wireAddButton);

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.cs-reveal');
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- AJAX load-more pagination ---------- */
  function wireLoadMore() {
    var loadMoreBtn = document.getElementById('csLoadMoreBtn');
    if (!loadMoreBtn || loadMoreBtn.dataset.csWired) return;
    loadMoreBtn.dataset.csWired = 'true';

    loadMoreBtn.addEventListener('click', function () {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Loading…';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('csProductGrid');
          var newLoadMore = doc.getElementById('csLoadMoreBtn');
          var newCards = newGrid ? newGrid.querySelectorAll('[data-cs-card]') : [];

          loadMoreBtn.remove();

          newCards.forEach(function (card) {
            card.classList.add('cs-card--enter');
            grid.appendChild(card);
            wireCard(card);
            var addBtn = card.querySelector('[data-cs-add-btn]');
            if (addBtn) wireAddButton(addBtn);
            void card.offsetWidth;
            card.classList.add('cs-card--enter-active');
            card.classList.add('is-visible'); // skip scroll-reveal delay for appended cards
          });

          if (newLoadMore) {
            grid.appendChild(newLoadMore);
            wireLoadMore();
          }

          var countEl = document.getElementById('csResultCount');
          var newCount = doc.getElementById('csResultCount');
          if (countEl && newCount) countEl.textContent = newCount.textContent;

          window.history.replaceState({}, '', nextUrl);
        })
        .catch(function () {
          window.location.href = nextUrl;
        });
    });
  }
  wireLoadMore();
})();
